/* Provider-aware video rendering for Cylindo gallery alternate content */
(function () {
  if (window.CylindoVideoPlayer) return;

  // Cache of players per container for reuse
  var playerCache = new WeakMap(); // container -> { node, provider, url, hls, savedTime, hasPlayedOnce }

  // Global mute preference for ALL videos (shared state across providers)
  var globalUserMuted = null; // Will be set based on setting when first video plays
  var hasAnyVideoPlayed = false; // Track if any video has played yet
  var currentActiveVideo = null; // Track the currently active video element

  function getGalleryReuseFlag() {
    var el = document.querySelector('media-gallery-cylindo');
    if (!el) return false;
    var attr = el.getAttribute('data-reuse-alt-players');
    return String(attr).toLowerCase() === 'true';
  }

  function getMuteVideoOnInitialPlaySetting() {
    var el = document.querySelector('media-gallery-cylindo');
    if (!el) return false;
    var attr = el.getAttribute('data-mute-video-on-initial-play');
    return String(attr).toLowerCase() === 'true';
  }

  function applyMuteStateToVideo(videoElement, isMuted) {
    if (!videoElement) return;

    // Check if it's a native video element
    if (videoElement.tagName === 'VIDEO') {
      videoElement.muted = isMuted;
    }
    // Check if it's an iframe (YouTube or Vimeo)
    else if (videoElement.tagName === 'IFRAME') {
      var isYT = /youtube|youtu\.be/.test(videoElement.src || '');
      var isVimeo = /vimeo\.com/.test(videoElement.src || '');

      if (isYT) {
        // YouTube: use setVolume or mute/unmute commands
        var command = isMuted ? 'mute' : 'unMute';
        videoElement.contentWindow &&
          videoElement.contentWindow.postMessage('{"event":"command","func":"' + command + '","args":""}', '*');
      } else if (isVimeo) {
        // Vimeo: try Vimeo Player SDK first, fallback to postMessage

        /**
         * Fallback function for Vimeo mute/unmute when SDK fails
         * @param {HTMLIFrameElement} el - The Vimeo iframe element
         * @param {boolean} muted - Whether to mute (true) or unmute (false)
         * @param {Error} reason - Optional error that caused the fallback
         */
        function vimeoFallback(el, muted, reason) {
          if (reason) console.warn('[CylindoVideoPlayer] Vimeo SDK fallback:', reason);
          if (!el || !el.contentWindow) return;

          // Use postMessage API as fallback when SDK fails
          if (muted) {
            el.contentWindow.postMessage({ method: 'setVolume', value: 0 }, '*');
            el.contentWindow.postMessage({ method: 'mute' }, '*');
          } else {
            el.contentWindow.postMessage({ method: 'unmute' }, '*');
            el.contentWindow.postMessage({ method: 'setVolume', value: 1 }, '*');
          }
        }

        if (window.Vimeo && window.Vimeo.Player) {
          try {
            // Get or create Vimeo Player instance for this iframe
            var vimeoPlayer = videoElement._vimeoPlayerInstance;
            if (!vimeoPlayer) {
              vimeoPlayer = new window.Vimeo.Player(videoElement);
              videoElement._vimeoPlayerInstance = vimeoPlayer;
            }

            /**
             * Create a promise chain for mute/unmute operations
             *
             * For muting: setVolume(0) → setMuted(true)
             * - Ensures volume is 0 before marking as muted
             *
             * For unmuting: setMuted(false) → setVolume(1)
             * - Ensures player is unmuted before setting volume to 100%
             *
             * Both operations can fail due to:
             * - Player not ready
             * - Network issues
             * - Vimeo API errors
             * - Browser security restrictions
             */
            var muteSequence = isMuted
              ? vimeoPlayer.setVolume(0).then(function () {
                  return vimeoPlayer.setMuted(true);
                })
              : vimeoPlayer.setMuted(false).then(function () {
                  return vimeoPlayer.setVolume(1);
                });

            // Execute the mute/unmute sequence
            muteSequence
              .then(function () {})
              .catch(function (error) {
                // SDK methods failed, fall back to postMessage
                vimeoFallback(videoElement, isMuted, error);
              });
          } catch (error) {
            // SDK initialization failed, fall back to postMessage
            vimeoFallback(videoElement, isMuted, error);
          }
        } else {
          // Vimeo Player SDK not available, use postMessage directly
          vimeoFallback(videoElement, isMuted);
        }

        // If URL doesn't have autoplay=1, trigger play (regardless of mute state)
        if (!videoElement.src.includes('autoplay=1')) {
          setTimeout(function () {
            if (videoElement.contentWindow) {
              videoElement.contentWindow.postMessage({ method: 'play' }, '*');
            }
          }, 500);
        }
      }
    }
  }

  function syncMuteTo(container) {
    if (!container) return;
    // Resolve initial global mute if not yet set
    if (globalUserMuted === null) {
      var initial = getMuteVideoOnInitialPlaySetting();
      globalUserMuted = initial;
    }
    var mediaEl = container.querySelector('video, iframe');
    if (mediaEl != null) {
      applyMuteStateToVideo(mediaEl, globalUserMuted);
    }
  }

  function addMuteStateListeners(videoElement, provider) {
    if (!videoElement) return;

    // Track this as the current active video
    currentActiveVideo = videoElement;

    if (provider === 'direct' && videoElement.tagName === 'VIDEO') {
      // Native video: listen for volumechange events
      videoElement.addEventListener('volumechange', function () {
        if (globalUserMuted !== videoElement.muted) {
          globalUserMuted = videoElement.muted;
        }
      });
    } else if (provider === 'youtube' && videoElement.tagName === 'IFRAME') {
      // YouTube: listen for postMessage events from the iframe
      window.addEventListener('message', function (event) {
        if (event.source === videoElement.contentWindow) {
          try {
            var data = JSON.parse(event.data);
            if (data.event === 'infoDelivery' && data.info) {
              // YouTube sends volume info in data.info.volume (0-100)
              var isMuted = data.info.volume === 0;
              if (globalUserMuted !== isMuted) {
                globalUserMuted = isMuted;
              }
            }
          } catch (e) {
            // Ignore non-JSON messages
          }
        }
      });
    } else if (provider === 'vimeo' && videoElement.tagName === 'IFRAME') {
      // Vimeo: Initialize Vimeo Player SDK and listen for volumechange events
      if (window.Vimeo && window.Vimeo.Player) {
        // Wait for iframe to load, then initialize Vimeo Player SDK
        videoElement.addEventListener('load', function () {
          try {
            var vimeoPlayer = new window.Vimeo.Player(videoElement);

            // Add volume change listener
            vimeoPlayer.on('volumechange', function (data) {
              // Update global mute state
              var isMuted = data.volume === 0 || data.muted;
              if (globalUserMuted !== isMuted) {
                globalUserMuted = isMuted;
              }
            });
          } catch (e) {
            console.error('[CylindoVideoPlayer] Error initializing Vimeo Player SDK:', e);
            // Fallback to postMessage listener if SDK fails
            addVimeoPostMessageListener(videoElement);
          }
        });
      } else {
        // Fallback to postMessage listener if Vimeo SDK not available
        addVimeoPostMessageListener(videoElement);
      }
    }
  }

  function addVimeoPostMessageListener(videoElement) {
    // Vimeo: listen for postMessage events from the iframe (fallback)
    window.addEventListener('message', function (event) {
      if (event.source === videoElement.contentWindow) {
        try {
          var data = JSON.parse(event.data);
          if (data.event === 'volumechange' && typeof data.data === 'object') {
            // Vimeo sends volume info in data.data.volume (0-1)
            var isMuted = data.data.volume === 0;
            if (globalUserMuted !== isMuted) {
              globalUserMuted = isMuted;
            }
          }
        } catch (e) {
          // Ignore non-JSON messages
        }
      }
    });
  }

  function createVideoElement(entry) {
    var video = document.createElement('video');
    video.setAttribute('controls', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'metadata');
    if (entry.poster) video.setAttribute('poster', entry.poster);
    if (Array.isArray(entry.sources)) {
      entry.sources.forEach(function (src) {
        var source = document.createElement('source');
        source.src = src.src;
        if (src.type) source.type = src.type;
        video.appendChild(source);
      });
    }
    return video;
  }

  function createIframe(src, className) {
    var iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.className = className || '';
    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', 'Product video');
    // Ensure iframe adopts current global mute state once it loads
    iframe.addEventListener('load', function () {
      if (globalUserMuted === null) {
        var initial = getMuteVideoOnInitialPlaySetting();
        globalUserMuted = initial;
      }
      applyMuteStateToVideo(iframe, globalUserMuted);
    });

    return iframe;
  }

  function renderInto(container, entry) {
    if (!container || !entry) return;
    var reuse = getGalleryReuseFlag();

    if (!reuse) {
      container.innerHTML = '';
    }
    var node;
    if (entry.provider === 'direct') {
      if (reuse) {
        var cachedNativePlayer = playerCache.get(container);
        if (cachedNativePlayer && cachedNativePlayer.provider === 'direct') {
          node = cachedNativePlayer.node;
        } else {
          node = createVideoElement(entry);
          playerCache.set(container, {
            node: node,
            provider: 'direct',
            savedTime: 0,
            hasPlayedOnce: false,
          });
          if (container.contains(node) === false) {
            container.innerHTML = '';
            container.appendChild(node);
          }
        }
      } else {
        node = createVideoElement(entry);
      }
    } else if (entry.provider === 'youtube') {
      if (reuse) {
        var cachedYoutubePlayer = playerCache.get(container);
        if (cachedYoutubePlayer && cachedYoutubePlayer.provider === 'youtube') {
          node = cachedYoutubePlayer.node;
        } else {
          node = createIframe(entry.url, 'js-youtube');
          playerCache.set(container, { node: node, provider: 'youtube', url: entry.url });
          container.innerHTML = '';
          container.appendChild(node);
        }
      } else {
        node = createIframe(entry.url, 'js-youtube');
      }
    } else if (entry.provider === 'vimeo') {
      if (reuse) {
        var cachedVimeoPlayer = playerCache.get(container);
        if (cachedVimeoPlayer && cachedVimeoPlayer.provider === 'vimeo') {
          node = cachedVimeoPlayer.node;
        } else {
          node = createIframe(entry.url, 'js-vimeo');
          playerCache.set(container, { node: node, provider: 'vimeo', url: entry.url });
          container.innerHTML = '';
          container.appendChild(node);
        }
      } else {
        node = createIframe(entry.url, 'js-vimeo');
      }
    } else if (entry.image) {
      var img = document.createElement('img');
      img.src = entry.image;
      img.alt = entry.description || '';
      img.setAttribute('draggable', 'false');
      node = img;
    }
    if (node && !reuse) container.appendChild(node);

    // Add mute state listeners for cross-provider mute state sharing
    if (node && (entry.provider === 'direct' || entry.provider === 'youtube' || entry.provider === 'vimeo')) {
      addMuteStateListeners(node, entry.provider);
    }

    // Immediately sync mute state to the newly rendered media before autoplay
    if (node && (entry.provider === 'direct' || entry.provider === 'youtube' || entry.provider === 'vimeo')) {
      syncMuteTo(container);
    }

    // attempt autoplay and apply mute state for all video types
    try {
      if (node && (entry.provider === 'direct' || entry.provider === 'youtube' || entry.provider === 'vimeo')) {
        var cached = playerCache.get(container);
        var isFirstPlay = !cached || !cached.hasPlayedOnce;

        // Apply global mute state to all video types
        if (!hasAnyVideoPlayed) {
          // First video ever - use the setting to determine initial mute state
          var muteOnInitialPlay = getMuteVideoOnInitialPlaySetting();

          globalUserMuted = muteOnInitialPlay;
          hasAnyVideoPlayed = true;
        } else {
          // Use global mute preference if it's been set by user interaction
          if (globalUserMuted !== null) {
            // console.log('[CylindoVideoPlayer] Using global mute preference:', globalUserMuted);
          } else {
            // Fallback to setting if global preference hasn't been set yet
            var muteOnInitialPlay = getMuteVideoOnInitialPlaySetting();

            globalUserMuted = muteOnInitialPlay;
          }
        }

        // Mark this container as having played
        if (cached && isFirstPlay) {
          cached.hasPlayedOnce = true;
        }

        // Apply mute state to the current video
        applyMuteStateToVideo(node, globalUserMuted);

        // HLS logic only applies to native videos
        if (entry.provider === 'direct' && node.tagName === 'VIDEO') {
          var hasHls =
            entry.sources &&
            entry.sources.some(function (s) {
              return (s.type || '').indexOf('mpegurl') !== -1 || (s.src || '').indexOf('.m3u8') !== -1;
            });
          var nativeHls = node.canPlayType('application/vnd.apple.mpegurl');
          var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
          // Force hls.js on mobile devices for better autoplay handling
          if (hasHls && (nativeHls === 'no' || nativeHls === 'maybe' || isMobile)) {
            // progressive enhancement for HLS via hls.js if available
            if (window.Hls) {
              var hls = new window.Hls();
              var hlsSrc = entry.sources.find(function (s) {
                return (s.src || '').indexOf('.m3u8') !== -1;
              });
              if (hlsSrc) {
                hls.loadSource(hlsSrc.src);
                hls.attachMedia(node);
                hls.on(window.Hls.Events.MANIFEST_PARSED, function () {
                  node.play().catch(function (e) {
                    console.error('[CylindoVideoPlayer] HLS play failed:', e);
                  });
                });
              }
            } else {
              console.warn('[CylindoVideoPlayer] hls.js not available, trying native playback (may fail on mobile)');
              // fallback: try play anyway (Safari iOS likely supports)
              node.play().catch(function (e) {
                console.error('[CylindoVideoPlayer] Native HLS play failed:', e);
              });
            }
          } else {
            node.play().catch(function (e) {
              console.error('[CylindoVideoPlayer] Play failed:', e);
            });
          }
        } // End of native video HLS logic
      }
    } catch (e) {
      console.error('[CylindoVideoPlayer] Error in autoplay:', e);
    }
    return node;
  }

  function pauseAndCleanup(container) {
    if (!container) return;
    var reuse = getGalleryReuseFlag();
    if (reuse) {
      // Pause but keep elements for reuse
      pause(container);
      return;
    }
    var video = container.querySelector('video');
    if (video) {
      try {
        video.pause();
      } catch (e) {}
      video.removeAttribute('src');
      var sources = video.querySelectorAll('source');
      sources.forEach(function (s) {
        s.removeAttribute('src');
      });
      video.load();
    }
    var iframe = container.querySelector('iframe');
    if (iframe) {
      // replace node to stop playback
      var parent = iframe.parentNode;
      if (parent) {
        var placeholder = document.createElement('div');
        parent.replaceChild(placeholder, iframe);
      }
    }
  }

  function pause(container) {
    if (!container) return;
    var video = container.querySelector('video');
    if (video) {
      try {
        video.pause();
        // Save playhead position for native videos
        var cachedNativePlayer = playerCache.get(container);
        if (cachedNativePlayer && cachedNativePlayer.provider === 'direct') {
          cachedNativePlayer.savedTime = video.currentTime;
        }
      } catch (e) {}
    }
    var iframe = container.querySelector('iframe');
    if (iframe) {
      try {
        var isYT = /youtube|youtu\.be/.test(iframe.src || '');
        var isVimeo = /vimeo\.com/.test(iframe.src || '');
        if (isYT) {
          iframe.contentWindow &&
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        } else if (isVimeo) {
          iframe.contentWindow && iframe.contentWindow.postMessage({ method: 'pause' }, '*');
        }
      } catch (e) {}
    }
  }

  function play(container) {
    if (!container) return;
    // Ensure the active media reflects the latest global mute before playing
    syncMuteTo(container);
    var video = container.querySelector('video');
    var iframe = container.querySelector('iframe');
    var videoElement = video || iframe;

    if (videoElement) {
      // Apply global mute state to all video types
      if (globalUserMuted !== null) {
        applyMuteStateToVideo(videoElement, globalUserMuted);
      }

      // Restore playhead position for native videos only
      if (video) {
        var cachedNativePlayer = playerCache.get(container);
        if (cachedNativePlayer && cachedNativePlayer.provider === 'direct') {
          if (typeof cachedNativePlayer.savedTime === 'number' && cachedNativePlayer.savedTime > 0) {
            video.currentTime = cachedNativePlayer.savedTime;
          }
        }
        video.play().catch(function () {});
      } else if (iframe) {
        // Play iframe videos
        try {
          var isYT = /youtube|youtu\.be/.test(iframe.src || '');
          var isVimeo = /vimeo\.com/.test(iframe.src || '');
          if (isYT) {
            iframe.contentWindow &&
              iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else if (isVimeo) {
            iframe.contentWindow && iframe.contentWindow.postMessage({ method: 'play' }, '*');
          }
        } catch (e) {}
      }
    }
  }

  function pauseAll() {
    document.querySelectorAll('.is-alt-content').forEach(function (c) {
      pause(c);
    });
  }

  function prune() {
    // WeakMap cleans up automatically; this is a no-op kept for API symmetry
  }

  window.CylindoVideoPlayer = {
    renderInto: renderInto,
    pauseAndCleanup: pauseAndCleanup,
    pause: pause,
    play: play,
    pauseAll: pauseAll,
    prune: prune,
  };
})();
